import _ from 'lodash';
import dayjs from 'dayjs';
import { MessageBox } from 'element-ui';

/**
 * @description 格式化查询参数
 * @param {Object} data 查询参数
 */
export const formatSearchData = data => {
    const params = _.cloneDeep(data);
    params.createTimeStart = params.createTime ? dayjs(params.createTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.createTimeEnd = params.createTime ? dayjs(params.createTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    delete params.createTime;
    return params;
};

export const formatTotalDataList = (data) => {
    if (!data.length) return [];
    data.forEach((item, index) => {
        item.tableIndex = index + 1;
        item.configFlag = String(item.configFlag);
    });
    return data;
};

/**
 * @description 按钮操作 二次确认的消息提示
 * @param {String} tipsInfo 提示信息
 * @param {String} api 调用的接口
 * @param {Array/String/Object} params 接口参数
 * @param {String} successTips 操作成功的提示
 * @param {Object} that 接收函数调用者的 this
 */
export const messageTips = (tipsInfo = '此操作将永久修改该数据, 是否继续？', api, params, successTips = '操作成功', that) => {
    MessageBox.confirm(tipsInfo, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = '执行中...';
                api(params)
                    .then(res => {
                        if (res && +res.code === 0) {
                            Message.success(successTips);
                            done();
                        }
                    })
                    .catch((errMsg) => {
                        Message.error(errMsg);
                    })
                    .finally(() => {
                        instance.confirmButtonLoading = false;
                        done();
                        that.getList();
                    });
            } else {
                done();
            }
        }
    }).catch(() => { }); // 添加错误捕获
};

export const urlToIflow = (path, queryObject = {}) => {
    const baseURL = window.location.href.split('#')[0];
    const queryStr = Object.keys(queryObject).map(k => `${k}=${queryObject[k]}`).join('&');
    if (queryStr) {
        return `${baseURL}#${path}?${queryStr}`;
    } else {
        return `${baseURL}#${path}`;
    }
};
